import { render, staticRenderFns } from "./filtered-items.vue?vue&type=template&id=5306e92d&"
import script from "./filtered-items.vue?vue&type=script&lang=ts&"
export * from "./filtered-items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports